import {
  ParticipantData,
  Peer,
  RemoteParticipant,
  Room,
  Stream
} from "@domain";
import { UniqueEntityId } from "@kernel/ddd";
import { SyncInteractor } from "@kernel/frontend-react-app";
import { UserType } from "modules/room/UserType";

export interface CreateRemoteParticipantInteractorProps {
  displayName: string;
  remoteId: number;
  type: UserType;
  peer: Peer;
  room: Room;
}

export class CreateRemoteParticipantInteractor extends SyncInteractor<
  CreateRemoteParticipantInteractorProps,
  RemoteParticipant
> {
  public execute(
    props: CreateRemoteParticipantInteractorProps
  ): RemoteParticipant {
    const participant = RemoteParticipant.create({
      data: ParticipantData.create({
        displayName: props.displayName,
        type: props.type
      }),
      pinned: false,
      stream: Stream.create({
        mediaStream: new MediaStream(),
        local: false,
        sourceType: "camera"
      }),
      peer: props.peer,
      remoteId: new UniqueEntityId(props.remoteId)
    });
    return participant;
  }

  public static create() {
    return new CreateRemoteParticipantInteractor();
  }
}
